import React from 'react'
import { buildHeaderCopy } from '../helpers'
import './style.css'

const SettingsPageHeader = ({ match, linkUrl="https://help.drift.com/article/customize-drift-help/" }) => {
  const { title, secondaryText } = buildHeaderCopy(match.params.settingPage)
  
  return (
    <div className="settings-page-header-wrapper">
      <h1 className="settings-page-header-title">{title}</h1>
      <p className="settings-page-secondary-text">
        {secondaryText}
        <a className="settings-page-header-learn-more" rel="noopener noreferrer" target="_blank" href={ linkUrl }> Learn More</a>
      </p>
    </div>
  )
}
export default SettingsPageHeader